import { render, staticRenderFns } from "./ReceiverText.vue?vue&type=template&id=4bcdbc80&scoped=true&lang=pug"
import script from "./ReceiverText.vue?vue&type=script&lang=js"
export * from "./ReceiverText.vue?vue&type=script&lang=js"
import style0 from "./ReceiverText.vue?vue&type=style&index=0&id=4bcdbc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcdbc80",
  null
  
)

export default component.exports